"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var ColumnVisibilityButton = (0, mobx_react_1.observer)(function (_a) {
    var toggle = _a.toggle, tooltip = _a.tooltip, disabled = _a.disabled, disabledReason = _a.disabledReason, className = _a.className, size = _a.size;
    return (react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.Preview, { className: className }), size: size, tooltip: {
            content: tooltip,
            size: !!disabled ? kaleidoscope_1.TooltipSize.Large : kaleidoscope_1.TooltipSize.Small,
        }, onClick: toggle, disabled: disabled, disabledReason: disabledReason }));
});
exports.default = ColumnVisibilityButton;
